"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SquareRootInchOfWaterColumn = exports.SquareRootPascal = void 0;
var uom_1 = require("uom");
//SquareRootPressure
exports.SquareRootPascal = uom_1.Unit.createBase("SquareRootPascal", "SquareRootPressure", "√Pa");
exports.SquareRootInchOfWaterColumn = uom_1.Unit.timesNumber("SquareRootInchOfWaterColumn", 1 / 0.06335029447, exports.SquareRootPascal);
//# sourceMappingURL=square-root-pressure.js.map